import { InputHTMLAttributes, useState } from 'react'

import { EyeClosed, Eye } from 'lucide-react'

import { Input } from './Input'

interface PasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string
}

export const PasswordInput = ({ name, ...props }: PasswordInputProps) => {
  const [see, setSee] = useState(false)
  return (
    <div className="relative">
      <Input name={name} type={see ? 'text' : 'password'} {...props} />
      <button
        type="button"
        className="absolute right-0 flex items-center pr-3 -translate-y-1/2 top-1/2 gap-x-1"
        onClick={() => setSee(s => !s)}
        tabIndex={-1}
      >
        {see ? (
          <Eye className="h-4 w-4 text-gray-500" />
        ) : (
          <EyeClosed className="h-4 w-4 text-gray-500" />
        )}
      </button>
    </div>
  )
}
